import React, { useState, useContext, useEffect, useMemo } from 'react'
import { applicationContext } from '../contexts'
import { varClass, loadValue, saveValue, getFiltersForPreset } from '../helpers'

const presetKey = 'channel-preset-value'

type TChannel = {
  channelUuid: string
  channelName: string
  channelDomain?: string
}
type TPreset = '' | 'css' | 'non-css' | 'creator'
interface ChannelPickerState {
  selectedChannel: TChannel | undefined
  setSelectedChannel: (newChannel: TChannel | undefined) => void
  preset: TPreset | undefined
  setPreset: (newPreset: TPreset | undefined) => void
  filters: { key?: string; label?: string; value?: string }[]
}

export const usePresetPickerState = (filterKeys?: {
  channelFilterKey?: string
  creatorFilterKey?: string
}): ChannelPickerState => {
  const { presetPickerState } = useContext<any>(applicationContext)

  const {
    channelFilterKey = 'channelUuids',
    creatorFilterKey = 'creatorNotIds',
  } = filterKeys || {}
  const filters = getFiltersForPreset(
    presetPickerState?.preset || '',
    channelFilterKey,
    creatorFilterKey
  )
  return {
    ...presetPickerState,
    filters,
  }
}

export const newPresetPickerState = () => {
  const [selectedChannel, setSelectedChannel] = useState(undefined)

  const originalPreset = useMemo(() => loadValue(presetKey) || '', [])
  const [preset, setPreset] = useState(originalPreset)
  useEffect(() => {
    if (preset !== originalPreset) {
      saveValue(presetKey, preset)
      window.location.reload()
    }
  }, [preset])

  return {
    selectedChannel,
    setSelectedChannel,
    preset,
    setPreset,
  }
}

// export const ChannelPicker = (props) => {
//   const [open, setOpen] = useState(false)
//   const ref = useRef()
//   useOutsideClick(ref, () => {
//     setOpen(false)
//   })
//
//   const channels = useApiGet('/channels/v1/list')
//
//   const { selectedChannel, setSelectedChannel } = useChannelPickerState()
//
//   return (
//     <div className="channel-picker" ref={ref}>
//       <div
//         className={varClass({
//           'channel-picker-control': true,
//           'open': open,
//         })}
//         onClick={() => setOpen(!open)}
//       >
//         <div className="input">
//           <div>
//             <SVG src="/images/aside-channels.svg" className="icon" />
//             <span>
//               {selectedChannel ? selectedChannel.channelDomain : 'All sites'}
//             </span>
//           </div>
//           <div>
//             <SVG src="/images/chevron-right.svg" className="chevron" />
//           </div>
//         </div>
//       </div>
//       <ul
//         className={varClass({
//           'channel-picker-list': true,
//           'shown': open,
//         })}
//       >
//         <li
//           className={varClass({
//             'disabled': isBlank(selectedChannel),
//           })}
//           onClick={() => {
//             if (!isBlank(selectedChannel)) {
//               setOpen(false)
//               setSelectedChannel(undefined)
//             }
//           }}
//         >
//           <SVG src="/images/aside-channels.svg" className="icon" />
//           All sites
//         </li>
//         {map(channels, (channel) => (
//           <li
//             key={channel.channelUuid}
//             onClick={() => {
//               setOpen(false)
//               setSelectedChannel(channel)
//             }}
//           >
//             <Logo src={channel.channelFaviconUrl} width={18} height={18} />
//             {channel.channelDomain}
//           </li>
//         ))}
//       </ul>
//     </div>
//   )
// }

export const PresetPicker = (props) => {
  const { className } = props

  const { preset, setPreset } = usePresetPickerState()

  return (
    <div
      className={varClass({
        'channel-preset-picker-control': true,
        [className]: !!className,
      })}
    >
      <select
        value={preset}
        onChange={(e) => {
          setPreset((e.target.value || '') as TPreset)
        }}
      >
        <option value="">All</option>
        <option value="css">CSS</option>
        <option value="non-css">Without CSS</option>
        <option value="creator">Creator</option>
      </select>
    </div>
  )
}
